module.exports = __webpack_public_path__ + "static/media/jquery.b3c5133f.webp";